import axios from 'axios';
import { apiUrl } from '../Config';

export const getIndustryOptions = async (employerId) => {
    try {
        // Always include employerId in payload (even if null/undefined)
        const payload = { employerId: employerId || null };        
        const response = await axios.get(
            `${apiUrl}/industry/active`,
            {
                params: { employerId: employerId || null },
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching industry options:', error);
        throw error;
    }
};